import constant from '@/common/resources/constant'
import _ from 'lodash'
import cookie from '@/common/utils/cookie'
import { getPooqzoneCheck } from '@/common/utils/request'

export const removePzInfoOnCookie = data => {
  cookie.removeItem('pzInfo', constant.URL_COOKIE_DOMAIN, '/')
  console.log('removePzInfoOnCookie : ', data)
  return data
}
export const removePzOnCookie = data => {
  cookie.removeItem('pz', constant.URL_COOKIE_DOMAIN, '/')
  console.log('removePzOnCookie : ', data)
  return data
}
const setPzInfo = data => {
  cookie.setItem('pzInfo', JSON.stringify(data), false, constant.URL_COOKIE_DOMAIN, '/')
  console.log('setPzInfo : ', data)
  return data
}
const getData = response => response.data

export default {
  // 웨이브온 체크
  wavveOnCheck () {
    if (cookie.isWavveOn()) {
      // console.log('wavveonCheck Else')
      // cookie.setItem('pz', JSON.stringify({ 'isPooqzone': false }), false, constant.URL_COOKIE_DOMAIN, '/')
      location.replace('/index.html')
      // router.push('/index.html')
    } else {
      console.log('wavveOnCheck')
      getPooqzoneCheck()
        .then(getData)
        .then(removePzInfoOnCookie) // 기존 pooqzone Temp 정보 삭제
        .then(setPzInfo) // pooqzone 페이지에서 읽을 수 있도록 임시 저장
        .then((data) => { // 푹존이면
          console.log('response: ', data)
          console.log('to wavveon')
          cookie.setItem('pz', JSON.stringify({ 'isPooqzone': false }), false, constant.URL_COOKIE_DOMAIN, '/')
          location.replace('/wavveon')
        }).catch((err) => { // 아니면
          console.log('catch wavveon Check')
          if (_.get(err, ['response', 'data', 'resultcode'], '') === '100') {
            removePzInfoOnCookie()
            removePzOnCookie()
            cookie.setItem('pz', JSON.stringify({ 'isPooqzone': false }), false, constant.URL_COOKIE_DOMAIN, '/')
            location.replace('/index.html')
          // router.push('/index.html')
          }
        })
    }
  }
}
